import React from "react";
import { isNullOrEmpty } from "./commonMobile";

//Todo: if possible, change most mp3 file imports to use public folder instead of "src\assets"
// NOT RECOMMENDED FOR IMAGE IMPORTS
// Use assetImg() instead
// Todo: move all files of these object to public folder
// Todo: change all these to assetPathKeys
// const pathKeys = {
// 	//Menu icons
// 	"sidemenu": require.context('../assets/img/svg/sidemenu/', false, /\.(png|svg)$/),
// 	"v2icons": require.context("../assets/img/v2icons/", false, /\.(png|svg)$/),
// 	"niuniu_menuicons": require.context("../assets/img/niuniu_menuicons/", false, /\.(png)$/),
// };

const mp3PathKeys = {
	//MP3 files
	"baccarat": require.context("../assets/mp3/baccarat/", false, /\.(mp3)$/),
	"baccarat_banker": require.context("../assets/mp3/baccarat/banker/", false, /\.(mp3)$/),
	"baccarat_player": require.context("../assets/mp3/baccarat/player/", false, /\.(mp3)$/),
	"baccarat_tie": require.context("../assets/mp3/baccarat/tie/", false, /\.(mp3)$/),

	"dragon_tiger_dragon": require.context("../assets/mp3/baccarat/dragon/", false, /\.(mp3)$/),
	"dragon_tiger_tiger": require.context("../assets/mp3/baccarat/tiger/", false, /\.(mp3)$/),

	//TTS files
	"result_m7": require.context("../assets/mp3/tts/m7/", false, /\.(mp3)$/),
	"result_m10": require.context("../assets/mp3/tts/m10/", false, /\.(mp3)$/),
	"result_m11": require.context("../assets/mp3/tts/m11/", false, /\.(mp3)$/),
	"result_m13": require.context("../assets/mp3/tts/m13/", false, /\.(mp3)$/),
	"result_m14": require.context("../assets/mp3/tts/m14/", false, /\.(mp3)$/),
	"result_m16": require.context("../assets/mp3/tts/m16/", false, /\.(mp3)$/),
	"result_m19": require.context("../assets/mp3/tts/m19/", false, /\.(mp3)$/),
	"result_m20": require.context("../assets/mp3/tts/m20/", false, /\.(mp3)$/),
	"result_numbers": require.context("../assets/mp3/tts/numbers/", false, /\.(mp3)$/),
};

//Default functions, no need to change
//Scans image files from a directory
//pathKey: pathKeys object above
// Update 11-11-2020: imageImporter is removed
// function imageImporter(pathKey: string) {
// 	const paths = pathKeys[pathKey];
// 
// 	if (!paths) {
// 		console.error("Unknown pathKey: " + pathKey);
// 		return [];
// 	}
// 
// 	const pathkeys = paths.keys();
// 	const output = {};
// 
// 	paths.keys().map(paths).forEach((fileName: string, idx: number) => {
// 		output[pathkeys[idx].replace("./", "").replace(/\.(png|gif)$/, "")] = fileName;
// 	});
// 
// 	return output;
// }

//Only used in image imports
//Paths relative to public directory
const assetPathKeys = {
	"sidemenu": "/assets/img/svg/sidemenu/",
	"v2icons": "/assets/img/v2icons/",
	"niuniu_menuicons": "/assets/img/niuniu_menuicons/",

	//Desktop Lobby
	"3d": "/assets/img/3d/",
	"preview": "/assets/img/previews/",
	//Semitransparent image on Desktop Lobby
	"game_icon": "/assets/img/game_icons/",

	"chips": "/assets/img/chips/",

	"icons": "/assets/img/icons/",

	"errors": "/assets/img/errors/",

	//Generic card images
	"baccarat": "/assets/img/baccarat/",

	//Gong Ball images
	"gb_cards": "/assets/img/games/m16/cards/",
	"gb_history": "/assets/img/games/m16/history/",

	//Game specific images
	"p12": "/assets/img/games/p12/",
	"m7": "/assets/img/games/m7/",
	"m8": "/assets/img/games/m8/",
	"m10": "/assets/img/games/m10/",
	"m11": "/assets/img/games/m11/",
	"m13": "/assets/img/games/m13/",
	"m14": "/assets/img/games/m14/",
	"m19": "/assets/img/games/m19/",
	"m20": "/assets/img/games/m20/",
	"m23": "/assets/img/games/m23/",

	//RaceBall ball images
	"m26": "/assets/img/games/m26/",

	//Shio Fights card images
	"m27": "/assets/img/games/m27/",

	"m29": "/assets/img/games/m29/",
	"m30": "/assets/img/games/m30/",
	"m31": "/assets/img/games/m31/",
	"m32": "/assets/img/games/m32/",
	"m39": "/assets/img/games/m39/",
	"m42": "/assets/img/games/m42/",

	//Shio Fight images
	"shio_fight_roadmap": "/assets/img/shio_fight/roadmap_icons/",
	"shio_fight_bottom": "/assets/img/shio_fight/bottom_icons/",

	//Language Icons on Desktop Header
	"lang": "/assets/img/lang/",

	"top_icons": "/assets/img/top_icons/"
};

function assumeImageName(imageName: string, ext: string) {
	return ![".svg", ".jpg", ".png", ".gif"]
		.filter(_ext => _ext !== ext)
		.some(_ext => imageName.indexOf(_ext) >= 0) ?
		imageName + ext : imageName;
}

/**
 * Returns img JSX.
 * @returns The img JSX.
 * @param pathKey Object key from assetPathKeys
 * @param imageName the image name
 * @param key (optional): use this only if the image element is in an array
 * @param classes (optional): use this if your image has CSS classes
 */
function assetImg(pathKey: string, imageName: string, key: string = "", classes: string = "") {
	// How to play
	if (pathKey.startsWith("howtoplay")) {
		const splitPathKey = pathKey.split("_");
		const pcode = splitPathKey.slice(-1).join("");
		const howToPlayImageName = assumeImageName(imageName, ".png");

		return (
			<img className={classes}
				key={key}
				src={"/assets/img/howtoplay/" + pcode + "/" + howToPlayImageName}
				alt={"win_" + pcode}
			/>
		);
	}

	// Win Number Gif
	if (pathKey.startsWith("win_number_gif")) {
		const splitPathKey = pathKey.split("_");
		const pcode = splitPathKey.slice(-1).join("");

		return (
			<img className={classes}
				key={key}
				src={getWinNumberGifPath(pcode) +
					imageName + ".gif"}
				alt={"win_" + pcode}
			/>
		)
	}
	
	// Other Images
	const imagePath = assetPathKeys[pathKey];
	const otherImageName = assumeImageName(imageName, ".png");

	return (
		<img className={classes}
			key={key}
			src={imagePath + otherImageName}
			alt={imageName} />
	);
}

/**
 * Same as assetImg()
 * @returns Plain text instead of JSX
 * @param pathKey 
 * @param imageName 
 * @param key 
 * @param classes 
 */
function plainAssetImg(pathKey: string, imageName: string, key: string = "", classes: string = "") {
	// Check if the filename contains how to play
	if (pathKey.indexOf("howtoplay") >= 0) {
		const splitPathKey = pathKey.split("_");
		const pcode = splitPathKey.slice(-1).join("");
		const newImageName = assumeImageName(imageName, ".png");

		// This part is intentionally unformatted
		return `<img class="${classes}"
key="${key}"
src="${"/assets/img/howtoplay/" + pcode + "/" + newImageName}"
alt=${newImageName} />`;
	}

	// Other images (not how to play)
	const imagePath = assetPathKeys[pathKey];
	const newImageName = imageName.indexOf(".svg") < 0 &&
		imageName.indexOf(".jpg") < 0 &&
		imageName.indexOf(".gif") < 0 ?
		imageName + ".png" : imageName;

	// This part is intentionally unformatted
	return `<img class="${classes}"
key="${key}"
src="${imagePath + newImageName}"
alt="${imageName}" />`;
}

function getPlainImageArray(strAry: string[], assetImgKey: string) {
	return strAry.map(num => plainAssetImg(assetImgKey, num)).join("");
}

/**
 * Get image array based on assetImg.
 * @returns An array of image JSX elements.
 */
function getImageArray(fileNameAry: string[], assetImgKey: string, extension = "") {
	const rand = Math.random();
	
	return (
		fileNameAry.map((item, idx) =>
			assetImg(
				assetImgKey,
				item + (!isNullOrEmpty(extension) ? "." + extension : ""),
				rand + "_" + idx)
		)
	);
}

/**
 * Get win number GIF path for win animation when socket.on loadNewValue event is fired.
 */
function getWinNumberGifPath(pcode: string) {
	return "/assets/img/win_number_gif/" + pcode + "/";
}


/**
 * Imports MP3 files, this is bad but we'll keep this way of importing MP3 files for now
 * @param pathKey One of the keys in mp3PathKeys
 */
function mp3Importer(pathKey: string): HTMLAudioElement[] {
	const paths = mp3PathKeys[pathKey];
	if (!paths) {
		console.error("Unknown key: " + pathKey);
		return [];
	}

	const pathkeys = paths.keys();
	const output = [];

	paths.keys().map(paths).forEach((item, idx) => {
		output[pathkeys[idx].replace("./", "").replace(".mp3", "")] = new Audio(item);
	});

	return output;
}

export {
	// imageImporter,
	mp3Importer,
	
	assetImg,
	plainAssetImg,

	getPlainImageArray,
	getImageArray,

	getWinNumberGifPath
};
